<template>
  <div class="nsale_ myPage_ poster_">
    <div class="list_">
      <div class="poster_outer">
        <img
          style="height: 100%;width: 100%;"
          v-if="step == '2'"
          class="poster_img"
          :src="uploadImg"
          alt="posterImg"
        />
        <div v-if="step == '2' && !isMiniprogram" class="saveTip">
          <span>长按可保存海报</span>
        </div>
      </div>

      <div class="item_" id="posterHtml" v-if="step == '1'">
        <div class="item_1">
          <img class="item_1img" :src="postInfo.img" alt="poster" />
          <img class="code_" :src="postInfo.qrcode" alt="code" />
        </div>
        <div class="item_2">
          <img class="item_2img" :src="postInfo.head" alt="code" />
          <div>
            <p class="txt txt1">{{ postInfo.name }}</p>
            <p class="txt txt2">
              {{ postInfo.des }}
            </p>
          </div>
        </div>
      </div>

      <div class="item_" id="posterHtml" v-if="step == '3'">
        <div class="item_1">
          <img class="item_1img" :src="postInfo.img" alt="poster" />
        </div>
        <div class="item_2">
          <cube-upload
            ref="upload"
            v-model="files"
            @files-added="addedHandler"
            @file-error="errHandler"
            @input="fileImg"
          >
            <div class="clear-fix">
              <cube-upload-btn :multiple="false">
                <div>
                  <img
                    class="item_2img"
                    v-if="!showBase64&&files[0]"
                    :src="files[0] && files[0].url"
                    alt="code"
                  />
                  <img
                    v-else-if="showBase64&&files[0]"
                    class="item_2img"
                    :src="postInfo.head"
                    alt="code"
                  />
                  <img
                    v-else
                    class="item_2img"
                    :src="postInfo.head"
                    alt="code"
                  />
                </div>
              </cube-upload-btn>
            </div>
          </cube-upload>

          <div style="margin-left:10px;width: 215px;" v-if="showPoster">
            <cube-input
              class="inputStyle"
              v-model="postInfo.name"
              placeholder="请输入您的姓名"
            ></cube-input>
            <cube-textarea
              :maxlength="30"
              :indicator="false"
              v-model="postInfo.des"
              placeholder="请输入您想说的话（30字以内）"
            ></cube-textarea>
          </div>
          <div v-else>
            <p class="txt txt1">{{ postInfo.name }}</p>
            <p class="txt txt2">
              {{ postInfo.des }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="outer_" v-if="showLoading">
      <cube-loading :size="28"></cube-loading>
    </div>

    

    <div v-if="step == '3'">
      <cube-button class="btn_" @click="handle">完成</cube-button>
    </div>
    <div v-else class="btn_wrap_">
      <cube-button class="btn_" @click="handleEdit">编辑海报</cube-button>
      <cube-button v-if="isMiniprogram" class="btn_ ghost_ mrg_l12_" @click="handleToPreview">前去保存</cube-button>
    </div>
    
    <!-- <img v-if="showBase64" :src="imgBase64" style="height:100px;width:100px;" alt="img"> -->
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import api from "@/utils/beeApi";
import { EXIF } from "exif-js";

export default {
  data() {
    return {
      files: [],
      imgBase64:'',
      showBase64:false,
      showLoading: false,
      inviteUrl: "",
      codeUrl: "",
      tempId: "",
      postInfo: {
        postImg: require("../../../assets/image/nsale/post.jpg"),
        name: "",
        head:'',
        des: ""
      },
      iosFirst: true, //ios系统生成海报偏移问题：ios第一次生成
      uploadImg: "", //上传后的链接地址
      posterImg: "", // 最终生成的海报图片
      showPoster: true,
      preview: true,
      step: "1",
      edit: false,
      isMiniprogram: false // 是否是在微信小程序里面
    };
  },
  mounted() {
    // this.showOptionMenu();
    this.hideOptionMenu();
    this.edit = this.$route.meta.edit;
    this.postInfo = JSON.parse(localStorage.getItem("postInfo"));

    // alert(this.postInfo.head,"--->")

    if (!this.edit && this.postInfo) {
      let st = setTimeout(() => {
        this.createPoster();
        this.showToast("正在生成海报");
        clearTimeout(st);
      }, 1000);
      console.log("postInfo =>", this.postInfo);
    }
    // this.fetchJsSdkSign();
    console.log('判断环境', wx)
    this.$wx.wxMiniProgram.getEnv((res) => { 
      console.log('判断环境 -> ', res.miniprogram);
      this.isMiniprogram = true;
    })
  },
  beforeRouteEnter(to, from, next) {
    console.log("beforeRouteEnter -->", to, from);
    next();
  },
  activated() {
    console.log("activated -> ", 1, this.$route);
  },
  methods: {
    handleToPreview () {
      this.$wx.wxMiniProgram.navigateTo({url: '/pages/downloadImg?url=' + encodeURIComponent(this._posterImg)})
    },
     // 判断设备为 ios
    isIos() {
      var u = navigator.userAgent;
      if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
        return true;
      }
      return false;
    },
    fileImg(files) {
      let that = this;
      let Orientation;

      console.log(files[0].file, "---->file");

      let file = files[0].file

      // this.imgPreview(e.target.files[0])
      if (file) {
        EXIF.getData(file, function() {
          // var a = EXIF.pretty(this)
          // alert(a[14])
          Orientation = EXIF.getTag(this, "Orientation");
          console.log(Orientation,'====>Orientation值')
          // window.alert(Orientation)
        });
      }

      let reader = new FileReader();

      let img = new Image();

      reader.readAsDataURL(file);

      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      let _this = this
      reader.onload = ev => {
        // alert("图片转base64:"+reader.result)
        // this.imgBase64 = reader.result
        img.src = ev.target.result;
        img.onload = function() {
          var imgWidth = this.width;
          var imgHeight = this.height;

          console.log(this.width);
          console.log(this.height);
          // alert(this.width)
          // alert(this.height)
          let ratio = imgWidth / imgHeight;
          if (imgWidth > imgHeight && imgWidth > 600) {
            imgWidth = 400;
            imgHeight = Math.ceil(400 / ratio);
          } else if (imgWidth < imgHeight && imgHeight > 900) {
            imgWidth = Math.ceil(200 * ratio);
            imgHeight = 200;
          }

          canvas.width = imgWidth;
          canvas.height = imgHeight;

          if (Orientation && Orientation != 1) {
            switch (Orientation) {
              case 6:
                canvas.width = imgHeight;
                canvas.height = imgWidth;
                ctx.rotate(Math.PI / 2);
                ctx.drawImage(this, 0, -imgHeight, imgWidth, imgHeight);
                break;
              case 3:
                ctx.rotate(Math.PI);
                ctx.drawImage(this, -imgWidth, -imgHeight, imgWidth, imgHeight);
                break;
              case 8: // 旋转-90度
                canvas.width = imgHeight;
                canvas.height = imgWidth;
                ctx.rotate((3 * Math.PI) / 2);
                ctx.drawImage(this, -imgWidth, 0, imgWidth, imgHeight);
                break;
            }
          } else {
            ctx.drawImage(this, 0, 0, imgWidth, imgHeight);
          }
          this.imgBase64 = canvas.toDataURL("image/jpeg", 0.9);
          // this.files[0].url = this.imgBase64 //旋转后的图片
          // console.log(this.imgBase64,"--->base64")
          _this.postInfo.head = this.imgBase64
          // _this.imgBase64 = this.imgBase64
          if(!_this.isIos()){
            _this.showBase64 = true
          }
          window.aa = this.imgBase64;
          // console.log(window.aa)
          var len = this.imgBase64.length;
          var size = len - (len / 8) * 2;
          console.log(size);
          // alert(size)

          // reader.onload = (ev) => {
          //   // alert("图片转base64:"+reader.result)
          //   this.imgBase64 = reader.result
          //   try {
          //     // localStorage.setItem('imgBase64', reader.result)
          //     window.aa = reader.result
          //   } catch (error) {
          //     // console.log("存储localstorage失败"+error)
          //
          //   }

          // try {
          //   // localStorage.setItem('imgBase64', reader.result)
          //   // window.aa = reader.result
          // } catch (error) {
          //   console.log("存储localstorage失败"+error)
          // }
          // alert('base64全局存储完成')
          // this.$router.push('/result/industry')
          // alert('push完成')
        };
      };
      console.log(this.showBase64)
    },
    imgPreview(file) {
      // let _this = this
      let Orientation;
      console.log(file);
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      EXIF.getData(file, function() {
        var a = EXIF.pretty(this);
        // alert(a[14])
        // alert(a[Orientation])
        console.log(a);
        Orientation = EXIF.getTag(this, "Orientation");
        // alert(EXIF.getTag(this, "Orientation"))
      });
      console.log(Orientation);
    },
    showToast(text) {
      this.$createToast({
        type: "alert",
        txt: text
      }).show();
    },
    addedHandler() {
      const file = this.files[0];
      file && this.$refs.upload.removeFile(file);
      console.log(this.files, "----this.files");
      // this.imgPreview(this.files[0].file)
    },
    errHandler(file) {
      // const msg = file.response.message
      this.$createToast({
        type: "warn",
        txt: "Upload fail",
        time: 1000
      }).show();
    },
    showOptionMenu() {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function onBridgeReady() {
          WeixinJSBridge.call("showOptionMenu");
        }
      );
    },
    hideOptionMenu() {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function onBridgeReady() {
          WeixinJSBridge.call("hideOptionMenu");
        }
      );
    },
    // hideOptionMenu() {
    //   try {
    //     WeixinJSBridge.call("hideOptionMenu");
    //   } catch (error) {}
    // },
    handle() {
      this.iosFirst = false;
      this.showPoster = false;
      let st = setTimeout(() => {
        this.createPoster();
        this.showToast("正在生成海报");
        clearTimeout(st);
      }, 1000);
    },
    fetchJsSdkSign() {
      // const url = encodeURIComponent(location.href.split("#")[0]);
      let url = location.href.split("#")[0];
      let _this = this;
      api
        .getJsJdkSign2({
          url: url
        })
        .then(res => res.data)
        .then(async data => {
          const { appId, jssdkReqData } = data;
          console.log(appId, jssdkReqData);
          let options = {
            // debug: true,
            appId: appId, // 必填，公众号的唯一标识
            timestamp: jssdkReqData.timestamp, // 必填，生成签名的时间戳
            nonceStr: jssdkReqData.noncestr, // 必填，生成签名的随机串
            signature: jssdkReqData.signature, // 必填，签名，见附录1
            jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"]
          };
          const { wxShare } = await this.$wx.wxConfig(options)
          let opstion = {
            title: "分享标题", // 分享标题
            link: window.location.href,
            imgUrl: _this.postInfo.head, // 分享图标
            desc: "点击查看产品海报",
            success: function() {
              console.log("success++");
            },
            error: function() {
              console.log("failed++");
            }
          };
          wxShare(opstion)
        });
    },
    // base64(data) {
    //   api.base64(data).then(res => {
    //     this.uploadImg = res.data.content;
    //     this.step = "2";
    //   });
    // },
    AndroisIos() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return true;
      } else if (isIOS) {
        return false;
      }
    },
    createPoster() {
      this.showLoading = true;
      // 生成海报
      let isAndroid = this.AndroisIos();
      let xNum = 0;
      if (isAndroid) {
        xNum = 15;
      } else if (this.iosFirst && !isAndroid) {
        xNum = 16;
      } else if (!this.iosFirst && !isAndroid) {
        xNum = 1;
      }
      // alert(isAndroid)
      console.log(isAndroid, window.scrollY);
      const vm = this;
      const domObj = document.getElementById("posterHtml");
      html2canvas(domObj, {
        useCORS: true,
        // timeout: 500, // 加载延时
        backgroundColor: null,
        width: domObj.offsetWidth, // 下面解决当页面滚动之后生成图片出现白边问题
        height: domObj.offsetHeight,
        // windowWidth: document.body.scrollWidth,
        // windowHeight: document.body.scrollHeight,
        // scrollY: 0,
        // scrollX: 0,
        x: xNum,
        y: 10,
        dpi: window.devicePixelRatio * 2, // 解决图片不清晰问题
        scale: 2,
        logging: false,
        // letterRendering: true,
        onclone(doc) {
          let e = doc.querySelector("#posterHtml");
          e.style.display = "block";
        }
      }).then(function(canvas) {
        // 在微信里,可长按保存或转发
        vm.posterImg = canvas.toDataURL("image/png");

        vm.step = "2";
        vm.uploadImg = vm.posterImg; //前端生成base64
        vm.showLoading = false;
        if (vm.isMiniprogram) {
          vm.uploadFile(vm.posterImg);
        }
        vm.showToast("海报已生成");
        // let data = { base64Img: vm.posterImg };  //接口返回一个链接，可以解决苹果分享不支持base64的问题
        // vm.base64(data);
      });
    },
    uploadFile (dataURL) {
        function dataURItoBuffer (dataURI) {
          var byteString = atob(dataURI.split(',')[1])
          var buffer = new ArrayBuffer(byteString.length)
          var view = new Uint8Array(buffer)
          for (var i = 0; i < byteString.length; i++) {
            view[i] = byteString.charCodeAt(i)
          }
          return buffer
        }
        function dataURItoBlob (dataURI) {
          var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
          var buffer = dataURItoBuffer(dataURI)
          return new Blob([buffer], { type: mimeString })
        }
        let blob = dataURItoBlob(dataURL);
        blob.name = '海报.png';
        let formData = new FormData();
        formData.append('file', blob, blob.name);
        this.inviteUploadFile(formData);
    },
    inviteUploadFile(data){
      api.inviteUploadFile(data).then(res => res.data).then(res => {
        this.$wx.wxMiniProgram.postMessage({ imgUrl: res.content });
        this._posterImg = res.content;
      })
    },
    handleEdit() {
      this.step = "3";
      this.showPoster = true;
    }
  }
};
</script>

<style scoped lang="scss">
.mrg_l12_ {
  margin-left: 12px !important;
}
.btn_wrap_ {
  display: flex;
  padding: 0 35px;
  .btn_ {
    flex: 1;
    &.ghost_ {
      border: 1px solid #ff4a35;
      background: inherit;
      color: #ff4a35;
    }
  }
}
.nsale_ {
  background: rgba(245, 245, 245, 1);
  min-height: 100vh;
  padding-bottom: 20px;
  .btn_ {
    width: 305px;
    height: 50px;
    background: rgba(255, 74, 53, 1);
    border-radius: 5px;
    margin: 10px auto;
  }
  .list_ {
    margin: 0 auto 20px;
    height: 614px;
    width: 345px;
    padding-top: 10px;
    .item_ {
      // width: 345px;
      .item_1 {
        height: 500px;
        position: relative;
        .item_1img {
          width: 100%;
          height: 100%;
        }
        .code_ {
          position: absolute;
          right: 6%;
          bottom: 6%;
          height: 73px;
          width: auto;
        }
      }
      .item_2 {
        border-radius: 0 0 10px 10px;
        background: url("../../../assets/image/newbee/bottom.png") no-repeat;
        background-size: 100% 100%;
        height: 115px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: rgba(102, 102, 102, 1);
        padding: 10px;
        .item_2img {
          width: 75px;
          height: 75px;
          border-radius: 50%;
        }
        .add_ {
          display: flex;
          align-items: center;
          justify-content: center;
          border: #f5f5f5 1px solid;
          color: #ccc;
          font-size: 24px;
        }
        .txt {
          text-align: left;
          margin-left: 10px;
        }
        .txt1 {
          margin-bottom: 10px;
          font-weight: bold;
          font-size: 18px;
          color: #333333;
        }
        .txt2 {
          width: 193px;
          line-height: 25px;
          text-align: left; 
          text-align: justify;
          color: #666666;
        }
      }
    }
  }

  .poster_outer {
    position: relative;
    .saveTip {
      position: absolute;
      left: 0;
      bottom: 120px;
      width: 345px;
      font-size: 11px;
      height: 25px;
      line-height: 25px;
      background: rgba(0, 0, 0, 1);
      opacity: 0.4;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        color: rgba(255, 255, 255, 1);
        opacity: 0.5;
      }
    }
  }

  .outer_ {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .saveTip {
    width: 345px;
    font-size: 11px;
    height: 25px;
    line-height: 25px;
    background: rgba(0, 0, 0, 1);
    opacity: 0.4;
    position: absolute;
    bottom: 140px;
    left: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      color: rgba(255, 255, 255, 1);
      opacity: 0.5;
    }
  }
}
</style>
